import { useSelector } from 'react-redux'
import { RoleName } from '@pbt/pbt-ui-components'

import FeatureToggle from '~/constants/featureToggle'
import { getFeatureToggle } from '~/store/reducers/constants'
import useHasRole from '~/utils/useHasRole'

/**
 * Hook to determine if Agent Chat is enabled for the current user
 * Combines two checks:
 * 1. User has Boarder role (an unused role in CVC clinics, used to give access to beta testers)
 * 2. AGENT_CHAT feature toggle is enabled
 */
export function useIsAgentChatEnabled(): boolean {
  const hasBoarderRole = useHasRole(RoleName.Boarder)
  const isAgentChatFTEnabled = useSelector(
    getFeatureToggle(FeatureToggle.AGENT_CHAT),
  )

  return (
    hasBoarderRole &&
    typeof isAgentChatFTEnabled === 'boolean' &&
    isAgentChatFTEnabled
  )
}
